import axios from 'axios';
import { ACCESS_TYPE, VENDING_URL } from '../atoms/const';

const getTotalSales = () => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}totalsales`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get(url, config);
};

const getOverviewSales = (days?: number, weeks?: number, month?: number) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}overview-sales?${days ? `numberOfDays=${days}` : ''}${weeks ? `&numberOfWeeks=${weeks}` : ''}${month ? `&numberOfMonths=${month}` : ''}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get(url, config);
};

const getAllRoutesLastWeeklySales = () => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}all-routes-lastweek-totalsales`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get(url, config);
};

const overview = {
  getTotalSales,
  getOverviewSales,
  getAllRoutesLastWeeklySales,
};

export default overview;
